<template>
    <div class="wrap">
        <div>
            <div>
                <el-button @click="addVer" type="primary" icon="el-icon-circle-plus-outline">添加新版本</el-button>
            </div>
            <div class="mt20">
                <el-input placeholder="标题/内容/版本号" class="w260 seekIpt" v-model="keyWord" @keyup.enter.native="search">
                    <i slot="suffix" class="el-input__icon el-icon-search" @click="search"></i>
                </el-input>
                <el-select class="ml20" v-model="verType" clearable placeholder="请选择APP版本类型" @change="verTypeChange">
                    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
                <el-date-picker v-model="startDate" type="date" placeholder="选择起始日期" class="w150 ml20" @change="changeDataPage"
                            :picker-options="beforeDate" value-format="yyyy-MM-dd"></el-date-picker>
                <span class="ml10 mr10">至</span>
                <el-date-picker v-model="endDate" type="date" placeholder="选择截止日期" class="w150" @change="changeDataPage"
                                :picker-options="afterDate" value-format="yyyy-MM-dd"></el-date-picker>
            </div>
        </div>
        <div class="mt10">
            <el-table :data="tableData" class="table-div r30 allDown movePoin" v-loading="tableLoading">
                <el-table-column show-overflow-tooltip width="60" label="序号">
                    <template slot-scope="scope">
                        {{(page.pageSize * (page.pageNum - 1) + scope.$index + 1)}}
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="type" label="应用类型" min-width="100">
                    <template slot-scope="scope">
                        <span>{{scope.row.type?scope.row.type:'-'}}</span>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="title" label="标题" min-width="100">
                    <template slot-scope="scope">
                        <span>{{scope.row.title?scope.row.title:'-'}}</span>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="code" label="升级版本号" min-width="100">
                    <template slot-scope="scope">
                        <span>{{scope.row.code?scope.row.code:'-'}}</span>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="version" label="版本" min-width="100">
                    <template slot-scope="scope">
                        <span>{{scope.row.version?scope.row.version:'-'}}</span>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="upContent" label="升级内容" min-width="100">
                    <template slot-scope="scope">
                        <span>{{scope.row.upContent?scope.row.upContent:'-'}}</span>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="upUrl" label="升级URL" min-width="100">
                    <template slot-scope="scope">
                        <span>{{scope.row.upUrl?scope.row.upUrl:'-'}}</span>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="forceFlag" label="是否强制升级" min-width="150">
                    <template slot-scope="scope">
                        <!-- <el-switch v-model="scope.row.forceFlag" :active-value="1" :inactive-value="0" active-text="是" inactive-text="否" style="margin-left:-26px"></el-switch> -->
                        <span>{{scope.row.forceFlag?scope.row.forceFlag:'-'}}</span>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="createTime" label="创建时间" min-width="100">
                    <template slot-scope="scope">
                        <span>{{scope.row.createTime?scope.row.createTime:'-'}}</span>
                    </template>
                </el-table-column>
                <el-table-column fixed="right" label="操作" min-width="160">
                    <template slot-scope="scope">
                        <el-button @click="detail(scope.row)" type="info" plain>详情</el-button>
                        <el-button @click="del(scope.row)" type="danger" plain>删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <ybPagination :page="page" @size-change="pageSizeChange" @current-change="pageCurrentChange" style="margin-top:20px;"></ybPagination>
            <ver-dialog v-if="verDialogVisible" :verData="verData" :ver-dialog-visible="verDialogVisible" @closeVerDialog="closeVerDialogVisible"></ver-dialog>
        </div>
        
    </div>
</template>
<script>
import ybPagination from '@/components/ybPagination'
import VerDialog from './VerDialog'
import * as version from '@/api/version'
import * as mapping from '@/utils/enumList'
export default {
    components: {
        ybPagination,
        VerDialog
    },
    data() {
        return {
            keyWord: '',
            verType: '',
            options: mapping.getKeyVal('appType'),
            startDate: '',
            endDate: '',
            beforeDate: {
                disabledDate: (time) => {
                    let before = new Date("2018-01-01") - 8.64e7;
                    let after = new Date();
                    let endDate = new Date(this.endDate)
                    if (this.endDate) {
                        return time.getTime() > endDate || time.getTime() > after || time.getTime() < before;
                    } else {
                        return time.getTime() > after || time.getTime() < before;
                    }
                }
            },
            afterDate: {
                disabledDate: (time) => {
                    let before = new Date("2018-01-01") - 8.64e7;
                    let after = new Date();
                    let startDate = new Date(this.startDate);
                    if (this.startDate) {
                        return time.getTime() < startDate - 8.64e7 || time.getTime() > after || time.getTime() < before;
                    } else {
                        return time.getTime() > after || time.getTime() < before;
                    }
                }
            },
            tableData:[],
            tableLoading: false,
            page: {
                pageNum: 1,
                pageSize: 10,
                total: 0
            },
            verData: {
                type: '',
                form: {}
            },
            verDialogVisible: false,
            appType: '',
            id: ''
        }
    },
    computed: {
        queryListParams: function() {
            return {
                current: this.page.pageNum,
                size: this.page.pageSize,
                startDate: this.startDate,
                endDate: this.startDate,
                keyword: this.keyWord,
                type: this.verType
            }
        }
    },
    methods: {
        // 启用禁用筛选
        verTypeChange(val) {
            this.page.pageNum = 1;
            this.getVerList();
        },
        // 添加版本
        addVer() {
            this.verData = {};
            this.verData.type = 'isAdd';
            this.verDialogVisible = true;
        },
        // 日期选择
        changeDataPage() {
            this.page.pageNum = 1;
            this.getVerList();
        },
        // 搜索筛选
        search() {
            this.page.pageNum = 1;
            this.getVerList();
        },
        getVerList() {
            this.tableLoading = true;
            version.getVersionList(this.queryListParams).then(r=>{
                if(r.code === 200) {
                    let data = r.data.records
                    data.forEach(el=>{
                        el.type = mapping.keyToVal('appType', el.type)
                        el.forceFlag = mapping.keyToVal('forceFlag', el.forceFlag)
                    })
                    this.tableData = data;
                    this.page.total = r.data.total;
                    this.tableLoading = false;
                }
            }).catch(e=>{})
        },
        // 详情
        detail(row) {
            this.verData.form = row;
            this.verData.type = 'isDetail';
            this.verDialogVisible = true;
        },
        // 删除
        del(row) {
            this.$confirm('是否确认删除版本? 此操作不可恢复!', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let appType = '';
                for(let key in mapping.enumList.appType) {
                    if(mapping.enumList.appType[key] === row.type) {
                        appType = key;
                    }
                }
                let delParams = {
                    appType: appType,
                    id: row.id
                }
                version.versionDel(delParams).then(r => {
                    if(r.code === 200) {
                        this.$message.success('删除成功!');
                    }
                    this.getVerList();
                }) 
            }).catch(e => {});
        },
        // 关闭dialog
        closeVerDialogVisible() {
            this.verDialogVisible = false;
        },
        // 页数改变
        pageCurrentChange(num) {
            if(num !== this.page.pageNum) {
                this.page.pageNum = num;
                this.getVerList();
            }
        },
        // 页数据量改变
        pageSizeChange(size) {
            if(size !== this.page.pageSize) {
                this.page.pageSize = size;
                this.getVerList();
            }
        }
    },
    mounted() {
        let obj = mapping.enumList.appType;
        let propertys = [];
        let result = Object.keys(obj).map((el) => {
            let propertysItem = {'value': el, 'label': obj[el]};
            propertys.push(propertysItem);
        });
        this.options = propertys;
        this.getVerList();
    }
}
</script>
<style lang="scss" scoped>
    .wrap {
        width: 100%;
        height: calc(100% - 40px);
        text-align: left;
    }
</style>